import LetsLinkBranding from './lets-link-branding';
import LetsLinkWireframing from './lets-link-wireframing';
import LetsLinkIdea from './lets-link-idea';
import LetsLinkDesign from './lets-link-design';
import LetsLinkDevelopment from './lets-link-development';
import LetsLinkMerch from './lets-link-merch';
import LetsLinkContact from './lets-link-contact';
import LetsLinkIntro from './lets-link-intro';

import styles from './lets-link-pages.module.css';
import { Timeline } from '../../components';

function LetsLinkPages() {
  return (
    <div className={styles.main}>
      <LetsLinkIntro className={styles.intro} />
      <LetsLinkIdea className={styles.idea} />
      <Timeline className={styles.timeline} />
      <LetsLinkWireframing className={styles.wireframe} />
      <LetsLinkBranding className={styles.branding} />
      <LetsLinkDesign className={styles.design} />
      <LetsLinkDevelopment className={styles.development} />
      <LetsLinkMerch className={styles.merch} />
      <div className={styles.delimiter} />
      <LetsLinkContact className={styles.contact} />
    </div>
  );
}

export default LetsLinkPages;
